/**
 * Formats a US phone number to national format: (XXX) XXX-XXXX.
 * Handles extensions (e.g. "ext. 987", ", extension 987", "#987", ",987")
 * and normalizes non-breaking hyphens (U+2011) to standard hyphens.
 */
export const formatPhoneNumber = (phoneNumber: string): string => {
  // Normalize non-breaking hyphens to standard hyphens
  const normalized = phoneNumber.replace(/\u2011/g, '-');

  // Split off extension: matches ", extension 987", ", ext. 987", ",987", "#987"
  const extensionMatch = normalized.match(
    /^(.+?)(?:[,#]\s*(?:extension\s*|ext\.?\s*)?(\d+)|\s+ext\.?\s*(\d+))$/i,
  );

  const numberPart = extensionMatch ? extensionMatch[1].trim() : normalized;
  const extension = extensionMatch ? (extensionMatch[2] ?? extensionMatch[3]) : undefined;

  const digits = numberPart.replace(/\D/g, '');

  let formatted: string;

  if (digits.length === 10) {
    formatted = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  } else if (digits.length === 11 && digits.startsWith('1')) {
    formatted = `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  } else {
    // Doesn't match expected US format — return as-is
    return phoneNumber;
  }

  return extension ? `${formatted} ext. ${extension}` : formatted;
};
